import { type FocusEvent, useState } from "react";
import { useIMask } from "react-imask";

import { BaseInput } from "src/components/ExerciseAttributeBaseInput";
import {
  type MaskedTempoInputProps,
  tempoMaskConfig,
  useMaskedInputRegistryCleanup,
} from "src/workouts/exerciseAttributeInput.shared";

export function MaskedTempoInput(props: MaskedTempoInputProps) {
  useMaskedInputRegistryCleanup(props.registryHandlers);

  const [opts] = useState({
    mask: "1-2-3-4",
    overwrite: true,
    autofix: true,
    blocks: {
      1: tempoMaskConfig,
      2: tempoMaskConfig,
      3: tempoMaskConfig,
      4: tempoMaskConfig,
    },
    prepare: (str: string) => str.toUpperCase(),
  });

  const iMask = useIMask(opts, {
    defaultValue: props.value,
    onComplete: (value) => {
      props.onChange(value);
    },
  });

  function setInputRef(ref: HTMLInputElement | null) {
    iMask.ref.current = ref;
  }

  function handleFocus(event: FocusEvent<HTMLInputElement>) {
    props.registryHandlers.onFocus(event.currentTarget);
    props.onFocus?.(event);
  }

  function handleBlur(event: FocusEvent<HTMLInputElement>) {
    props.registryHandlers.onBlur(event.currentTarget);
    props.onBlur?.(event);
  }

  return (
    <BaseInput
      disabled={props.disabled}
      placeholder="Tempo"
      onBlur={handleBlur}
      onFocus={handleFocus}
      ref={setInputRef}
      className={"w-[70px]"}
    />
  );
}
